import type { ContextMenuAction } from '../../explorer/models/TreeModel';
import type { StorageService } from '../../../types/azureStorage';
import type { StorageServiceFolderNode } from '../../explorer/models/nodeTypes';
import { storageNodeId } from '../../explorer/models/azureStorageNodeFactories';
import type { StorageMenuNode } from './storageContextMenuService';

export type StorageMenuContext = { readOnly: boolean };
export type StorageTreeSlice = 's2' | 's5' | 's3' | 's4' | 's7' | 's8';
export type StorageServiceFolderAction = { id: string; label: string };

export type StorageTreeExtension = {
  id: string;
  slice: StorageTreeSlice;
  menuItems(node: StorageMenuNode, ctx: StorageMenuContext): ContextMenuAction[];
  serviceFolderActionRows?(service: StorageService): readonly StorageServiceFolderAction[];
};

const sliceOrder: readonly StorageTreeSlice[] = ['s2', 's5', 's3', 's4', 's7', 's8'];
const extensions = new Map<string, StorageTreeExtension>();

const orderedExtensions = () => [...extensions.values()].sort(
  (left, right) => sliceOrder.indexOf(left.slice) - sliceOrder.indexOf(right.slice) || left.id.localeCompare(right.id),
);

export function registerStorageTreeExtension(extension: StorageTreeExtension): () => void {
  extensions.set(extension.id, extension);
  return () => {
    if (extensions.get(extension.id) === extension) extensions.delete(extension.id);
  };
}

export function getStorageMenuItems(node: StorageMenuNode, ctx: StorageMenuContext): ContextMenuAction[] {
  return orderedExtensions().flatMap((extension) => extension.menuItems(node, ctx));
}

export function serviceFolderActionRows(service: StorageService): readonly StorageServiceFolderAction[] {
  return orderedExtensions().flatMap((extension) => extension.serviceFolderActionRows?.(service) ?? []);
}

export function storageActionNodeId(service: StorageServiceFolderNode, actionId: string): string {
  return `${storageNodeId(service.metadata.connectionId, service.metadata.resource)}:action:${actionId}`;
}
